import { request } from '@mirai/data-sources';
import { parseDate, dateFormat } from '@mirai/locale';

import { IS_JEST } from '../../../../components/helpers';
import { loadScript } from '../../../../helpers';
import { formatPrice } from '../helpers/legacy';

export const bookingResponse = async ({
  response: { tracking = {} } = {},
  store: { hotel: { id: hotelId } = {}, urlParams: { utm_source: source } = {} } = {},
} = {}) => {
  // ! -- TODO: use of tracking should be a temporary approach ---------------------------------------------------------
  const {
    bookingValues: { checkin, checkout, nights } = {},
    hotelInfo = {},
    idReservation,
    totalNumAdults = 0,
    totalNumChildren = 0,
    totalNumRooms,
    totalPriceWithTaxes,
    totalPriceWithoutTaxes,
  } = tracking;

  const { currency: hotelCurrency = {} } = hotelInfo;

  const value = {
    hotelId,
    transactionId: idReservation,
    checkin: checkin
      ? dateFormat(parseDate(checkin, 'DD/MM/YYYY'), { format: 'YYYY-MM-DD', delimiter: '-' })
      : undefined,
    checkout: checkout
      ? dateFormat(parseDate(checkout, 'DD/MM/YYYY'), { format: 'YYYY-MM-DD', delimiter: '-' })
      : undefined,
    nights,
    totalPriceWithTaxes: formatPrice(totalPriceWithTaxes, hotelCurrency),
    totalPriceWithoutTaxes: formatPrice(totalPriceWithoutTaxes, hotelCurrency),
    currency: hotelCurrency.code,
    rooms: totalNumRooms,
  };

  window.MiraiMeta = { ...window.MiraiMeta, ...value, guests: totalNumAdults + totalNumChildren };

  !IS_JEST &&
    (await loadScript({
      id: 'mirai-pixel',
      src: `${process.env.SERVICE_METAS}/connectivity/confirmation/mirai?${new URLSearchParams({
        ...value,
        ...(source ? { source } : {}),
      })}`,
    }).catch((error = {}) => {
      request({
        credentials: 'include',
        endpoint: `/connectivity/trackPixelError?o=GTM_MIRAI&t=${idReservation}&n=${error.name}&m=${error.message}`,
        hostname: process.env.SERVICE_METAS,
        method: 'GET',
      });
    }));

  return value;
};
